import BasketController from '../components/basket-controller.js';

export default class PageTransition {
    constructor() {
        let barbaLoadedPromise = null;
        let importGsapPromise = null;
        let barbaInitialized = false;
        let topNavigationPromise = null;
        const pageTransitionEnabledBreakpoint = 1000;
        const basketElem = document.querySelector('[data-component="basket-controller"]');

        // Checks if the screen is above a certain breakpoint, because we only want to animate on "big" screens
        const isValidScreenSizeForAnimation = function () {
            const valid = window.innerWidth >= pageTransitionEnabledBreakpoint;
            return valid;
        };

        const getTopNavigation = function () {
            if (!topNavigationPromise) {
                topNavigationPromise = window.cr.getGlobalInstance('top-navigation');
            }

            return topNavigationPromise;
        };

        const importGsap = function () {
            if (!importGsapPromise) {
                importGsapPromise = import('gsap')
                    .then(({ gsap }) => {
                        return gsap;
                    });
            }
            return importGsapPromise;
        };

        let gsap;
        importGsap()
            .then(gsapImp => {
                gsap = gsapImp;
            });

        const importBarba = function () {
            if (!barbaLoadedPromise) {
                barbaLoadedPromise = import('@barba/core')
                    .then(importResult => {
                        return importResult.default;
                    });
            }
            return barbaLoadedPromise;
        };

        /*
            callback functions to initialize and desctruct home page.
        */
        const homeView = {
            namespace: 'home',
            beforeLeave(data) {
                const delayAmount = data.next.namespace === 'calendar' ? 1 : 0.3;
                gsap.to('html', { '--animate-logo': 1, duration: delayAmount });
            },
            afterLeave() {
                document.querySelector('.top-navigation--hero-style')?.classList.remove('top-navigation--hero-style');
                window.listenToScroll = false;
                document.querySelector('.animating-hero')?.classList.remove('animating-hero');
            },
            beforeEnter(data) {
                window.listenToScroll = true;
                window.getSessionData();

                if (!data.current.container) {
                    document.querySelector('html').style.setProperty('--animate-logo', 0);
                } else {
                    gsap.to('html', { '--animate-logo': 0, duration: 1 });
                }

                document.querySelector('.top-navigation')?.classList.add('top-navigation--hero-style');
            },
        };

        const calendarPageView = {
            namespace: 'calendar',
            afterLeave() {
                document.body.classList.remove('calendar-page-nav');
                document.body.classList.remove('calendar-page-nav--scrolled');
            },
            before() {
                window.loadToolbar();
            },
        };

        const eventView = {
            namespace: 'event',
            beforeLeave() {
                document.body.style.removeProperty('--page-theme-color');
                document.body.style.removeProperty('--page-text-color');
                document.querySelector('.top-navigation')?.classList.remove('top-navigation--event-page');
            },
            afterEnter() {
                window.getSessionData();
                requestAnimationFrame(() => {
                    document.querySelector('.top-navigation')?.classList.add('top-navigation--event-page');

                    const event = document.querySelector('[data-page-theme-color]');
                    if (event) {
                        document.body.style.setProperty('--page-theme-color', event.dataset.pageThemeColor);
                        document.body.style.setProperty('--page-text-color', event.dataset.pageTextColor);
                    }
                    document.body.classList.remove('calendar-page-nav--scrolled');
                });
            },
        };

        const drBilletView = {
            namespace: 'ticket',
            beforeLeave() {
                document.body.style.removeProperty('--page-theme-color');
                document.body.style.removeProperty('--page-text-color');
            },
            after() {
                window.loadToolbar();
                window.getSessionData();
            },
        };

        window.loadToolbar = function () {
            const toolbarData = JSON.parse(document.querySelector('[data-toolbar]').dataset.toolbar);
            const toolbar = document.querySelector('.top-navigation__toolbar__home');
            const [image, link, name] = ['data-image', 'data-link', 'data-name'].map(attribute => toolbar.querySelector(`[${attribute}]`));
            image.src = toolbarData.ImageUrl;
            link.href = toolbarData.Link;
            name.innerText = toolbarData.Name;
            link.toggleAttribute('data-toggle-filter', toolbarData.IsFilterToggle);
            link.toggleAttribute('data-tours-link', toolbarData.IsToursToggle);
            if (toolbarData.ProductCategoryGroupingText) {
                link.setAttribute('data-add-on-link', toolbarData.ProductCategoryGroupingText);
            } else {
                link.removeAttribute('data-add-on-link');
            }
            toolbar.style = `--home-link-bg: ${toolbarData.Background}; --home-link-color: ${toolbarData.Color}`;
        };

        function calcActive(data) {
            const nextUrl = data.next.url.path;
            document.querySelectorAll('.top-navigation__menu-item__main-link').forEach(x => {
                const url = x.dataset.url;
                if (url && x) {
                    x.classList.toggle('top-navigation__menu-item__main-link--active', nextUrl.includes(url));
                }
            });
        }


        function removeAllBodyClasses() {
            window.closeSearch();
            document.body.classList.remove('filter-open');
            document.body.classList.remove('modal-open');
            document.body.classList.remove('no-header');
            document.body.classList.remove('menu-open');
            document.body.classList.remove('calendar-page-nav--scrolled');
        }

        /*
            Default page transition that will run on all pages, unless a more specific one is found.
         */

        const defaultTransition = {
            name: 'default-transition',
            leave(data) {
                window.timeouts.forEach(timeout => {
                    window.clearTimeout(timeout);
                });

                topNavigationPromise
                    .then(topNavigation => {
                        topNavigation.toggleHeroNavigationType(false);
                    });
                window.dispatchEvent(new Event('navigate'));
                calcActive(data);
                document.body.classList.remove('calendar-page-nav');
                removeAllBodyClasses();
                document.querySelector('top-navigation--hero-style')?.classList.remove('top-navigation--hero-style');
            },
            enter() {
                topNavigationPromise
                    .then(topNavigation => {
                        topNavigation.removeCurtain();
                    });
                window.loadObserver(true);
            },
            after() {
                window.loadToolbar();
                window.getSessionData();
                document.querySelector('top-navigation--hero-style')?.classList.remove('top-navigation--hero-style');
                new BasketController(basketElem);
            },
        };

        function delay(n) {
            const newDelay = n || 2000;
            return new Promise(done => {
                setTimeout(() => {
                    done();
                }, newDelay);
            });
        }


        /*
            Page transtion for navigation to calendar page from top menu link.
         */
        const homeToCalendarPageTransition = {
            name: 'homeToCalendarPageTransition',
            from: {
                // namespace: ['home'],
                custom: ({ trigger }) => {
                    if (!isValidScreenSizeForAnimation()) { return false; }

                    if (!trigger.getAttribute) { return false; }

                    const result = trigger.getAttribute('data-barba-transition');

                    if (!result) { return false; }
                    return result === 'menu-to-calendar';
                },
            },
            to: {
                namespace: ['calendar'],
            },
            async leave(data) {
                const menuItems = document.querySelector('.top-navigation__menu-items');
                const contentContainer = document.querySelector('.top-navigation__content-container');
                document.body.style.setProperty('--main-menu-width', menuItems.getBoundingClientRect().width + 'px');
                document.body.style.setProperty('--menu-items-left', menuItems.getBoundingClientRect().left + 'px');
                document.body.style.setProperty('--content-container-width', contentContainer.getBoundingClientRect().width + 'px');

                calcActive(data);
                window.dispatchEvent(new Event('navigate'));
                window.loadToolbar();
                document.querySelector('.top-navigation')?.classList.add('top-navigation--calendar-animation');
                topNavigationPromise
                    .then(topNavigation => {
                        topNavigation.animateInCurtain();
                        const tl = gsap.timeline();
                        tl.fromTo(data.current.container, { opacity: 1 }, { duration: 0.5, opacity: 0.5 });
                    });
                await delay(1000);
                document.querySelector('.top-navigation')?.classList.remove('top-navigation--calendar-animation');
                removeAllBodyClasses();
            },
            enter() {
                window.loadObserver(true);
            },
            after() {
                window.loadToolbar();
                window.getSessionData();
                document.querySelector('.top-navigation--hero-style')?.classList.remove('top-navigation--hero-style');
            },
        };

        const calendarPageToEventTransition = {
            name: 'calendarPageToEventTransition',
            from: {
                namespace: ['calendar'],
            },
            to: {
                namespace: ['event'],
            },
            async leave(data) {
                const onCalendarPage = data.trigger.getRootNode().querySelector('.calendar-page');
                if (onCalendarPage) {
                    localStorage.setItem('calendarScroll', window.scrollY);
                }

                calcActive(data);
                window.dispatchEvent(new Event('navigate'));
                window.loadToolbar();
                const closest = data.trigger.closest('.event-card, .featured-block');
                if (closest) {
                    closest?.classList.add('calendar-to-event--clicked');
                    document.body.classList.add('calendar-to-event');

                    const isEvent = closest.classList.contains('event-card');
                    const animateImage = isEvent && closest.querySelector('.event-card__media');
                    if (!animateImage) {
                        closest.classList.add('calendar-to-event--dont-animate-content');
                    }

                    document.body.style.setProperty('--page-theme-color', '#0f05a0');
                    if (closest.classList.contains('event-card--list-view')) {
                        return;
                    }

                    if (animateImage) {
                        const picture = closest.querySelector('picture');
                        const source = document.createElement('source');
                        const img = closest.querySelector('img');
                        source.srcset = img.src;
                        source.type = 'image/webp';
                        picture.insertBefore(source, picture.firstChild);

                        closest.setAttribute('style', 'transform: unset !important');
                        await delay(800);
                        if (isEvent) {
                            gsap.to('body', { '--page-theme-color': closest.dataset.themeColorAnimate, duration: 0.75 });
                        }

                        const imgContainer = closest.querySelector('.event-card__media');
                        if (imgContainer) {
                            const rect = imgContainer.getBoundingClientRect();
                            imgContainer.style.left = rect.left + 'px';
                            imgContainer.style.right = rect.right + 'px';
                            imgContainer.style.top = rect.top + 'px';
                            imgContainer.style.width = rect.width + 'px';
                            requestAnimationFrame(() => {
                                imgContainer.style.position = 'fixed';
                            });
                            await delay(5);

                            requestAnimationFrame(() => {
                                imgContainer.classList.add('event-card__media--animate');

                                requestAnimationFrame(() => {
                                    const breakpoint = window.matchMedia('(min-width: 992px) and (max-width: 1200px)');
                                    imgContainer.style.top = '90px';

                                    if (breakpoint.matches) {
                                        const widthCalc = `min(85vh * ${closest.dataset.aspectRatio}, 100vw - 90px)`;
                                        imgContainer.style.left = '0px';
                                        imgContainer.style.right = `calc((100vw - ${widthCalc}))`;
                                        imgContainer.style.width = `calc(${widthCalc})`;
                                    } else {
                                        const widthCalc = `min(85vh * ${closest.dataset.aspectRatio}, 100vw - calc(var(--event-side-padding) * 2))`;
                                        imgContainer.style.left = `calc((100vw - ${widthCalc}) / 2)`;
                                        imgContainer.style.right = `calc((100vw - ${widthCalc}) / 2)`;
                                        imgContainer.style.width = `calc(${widthCalc})`;
                                    }
                                });
                            });
                        }

                        await delay(1000);
                    } else {
                        if (isEvent) {
                            gsap.to('body', { '--page-theme-color': closest.dataset.themeColor, duration: 0.5 });
                            await delay(550);
                            closest.style.opacity = 0;
                            await delay(400);
                        }
                    }
                }
                document.body.classList.remove('calendar-page-nav');
                removeAllBodyClasses();
            },
            enter() {
                window.loadObserver(true);
            },
            after() {
                window.loadToolbar();
                window.getSessionData();
                document.body.classList.remove('calendar-to-event');
            },
        };

        this._init = function () {
            if (!barbaInitialized) {
                importBarba()
                    .then(barba => {
                        getTopNavigation();
                        barba.init({
                            debug: true,
                            timeout: 15000,
                            views: [homeView, eventView, drBilletView, calendarPageView],
                            sync: true,
                            transitions: [homeToCalendarPageTransition, defaultTransition, calendarPageToEventTransition],
                            prevent: ({ el }) => {
                                return el.closest('[data-no-barba]');
                            },
                        });

                        barba.hooks.enter((data) => {

                            // unload components from last page
                            window.cr.unload(data.current.container);

                            // load components for new page
                            window.cr.initializeComponentClasses(data.next.container);
                            window.cr.load(data.next.container);

                            // scroll page to top
                            window.scroll({ top: 0, left: 0, behavior: 'instant' });

                            return topNavigationPromise
                                .then(topNavigation => {
                                    topNavigation.toggleHeroNavigationType(data.next.namespace === 'home');
                                });
                        });
                        barba.hooks.leave(() => {
                            document.body.classList.remove('search-bar-open');
                            // Close the topNavigation before leaving the page.
                            return topNavigationPromise
                                .then(topNavigation => {
                                    topNavigation.close();
                                });
                        });

                        barbaInitialized = true;
                    });
            }
        };
    }

    init() {
        this._init();
    }
}
